import { Home, ArrowLeft, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Number */}
        <div className="mb-6">
          <h1 className="text-6xl font-bold text-[#0A0A0A] mb-2">404</h1>
          <div className="h-1 w-16 bg-[#00C56E] mx-auto"></div>
        </div>

        {/* Error Message */}
        <h2 className="text-2xl font-semibold text-[#0A0A0A] mb-3">
          Page non trouvée
        </h2>
        <p className="text-sm text-gray-600 mb-8 leading-relaxed">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée. 
          Veuillez vérifier l'URL ou retourner à l'accueil.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-lg hover:bg-[#1a1a1a] transition-colors"
          >
            <Home className="h-4 w-4" />
            Retour à l'accueil
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border-2 border-[#00C56E] text-[#00C56E] text-sm font-medium rounded-lg hover:bg-[#00C56E] hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Page précédente
          </button>
        </div>


      </div>
    </div>
  );
}